export var POSITIONS = ['left', 'top', 'right', 'bottom'];